export function notificationsChanged(props, nextProps) {
    if (props === nextProps || !props || props.notifications === nextProps.notifications || !props.notifications)
        return false

    const n = props.notifications
    const nextN = nextProps.notifications
    if (n.length !== nextN.length)
        return true

    for (let i = 0; i < n.length; i++) {
        if (n[i].id !== nextN[i].id)
            return false
    }

    return true
}


// WEBPACK FOOTER //
// ./src/utils/notifications.js